import { SET_FOOTER_DATA } from "../actions/setFooterData";


const initialState = {
  main_blocks: [{}, {}, {}]
}

export const footerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FOOTER_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}